var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as FileService from "../service/file-service.js";
import { ResourceProperty } from "./ResourceProperty.js";
/**
 *
 * This class defines a File uploaded to a [[Book]].
 *
 * A File can be attached to a [[Transaction]] or used to import data.
 *
 * @public
 */
export class File extends ResourceProperty {
    constructor(book, payload) {
        super(payload || { createdAt: `${Date.now()}` });
        this.book = book;
    }
    /**
     * Gets the Book this File belongs to.
     *
     * @returns The Book instance that owns this File
     */
    getBook() {
        return this.book;
    }
    /** @internal */
    getConfig() {
        return this.book.getConfig();
    }
    /**
     * Gets the File id.
     *
     * @returns The File id
     */
    getId() {
        return this.payload.id;
    }
    /**
     * Gets the File name.
     *
     * @returns The File name
     */
    getName() {
        return this.payload.name;
    }
    /**
     * Sets the name of the File.
     *
     * @param name - The name to set
     *
     * @returns This File, for chaining
     */
    setName(name) {
        this.payload.name = name;
        return this;
    }
    /**
     * Gets the File content type.
     *
     * @returns The File content type
     */
    getContentType() {
        return this.payload.contentType;
    }
    /**
     * Sets the File content type.
     *
     * @param contentType - The content type to set
     *
     * @returns This File, for chaining
     */
    setContentType(contentType) {
        this.payload.contentType = contentType;
        return this;
    }
    /**
     * Gets the file content Base64 encoded.
     *
     * @returns The file content Base64 encoded
     */
    getContent() {
        return __awaiter(this, void 0, void 0, function* () {
            const id = this.getId();
            if (this.getId() != null &&
                (this.payload == null || this.payload.content == null) &&
                this.book &&
                id) {
                this.payload = yield FileService.getFile(this.book.getId(), id, this.getConfig());
            }
            return this.payload.content;
        });
    }
    /**
     * Sets the File content Base64 encoded.
     *
     * @param content - The content to set (Base64 encoded)
     *
     * @returns This File, for chaining
     */
    setContent(content) {
        this.payload.content = content;
        return this;
    }
    /**
     * Gets the file serving url for accessing via browser.
     *
     * @returns The file serving url
     */
    getUrl() {
        return this.payload.url;
    }
    /**
     * Gets the file size in bytes.
     *
     * @returns The file size in bytes
     */
    getSize() {
        return this.payload.size;
    }
    /**
     * Gets the date the File was created.
     *
     * @returns The date the File was created
     */
    getCreatedAt() {
        return this.payload.createdAt ? new Date(new Number(this.payload.createdAt).valueOf()) : undefined;
    }
    /**
     * Perform create new File.
     *
     * @returns The created File object
     */
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield FileService.createFile(this.book.getId(), this.payload, this.getConfig());
            return this;
        });
    }
    /**
     * Perform update File, applying pending changes.
     *
     * @returns The updated File object
     */
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield FileService.updateFile(this.book.getId(), this.payload, this.getConfig());
            return this;
        });
    }
    /**
     * Perform delete File.
     *
     * @returns This File after deletion
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield FileService.deleteFile(this.book.getId(), this.payload, this.getConfig());
            return this;
        });
    }
}
//# sourceMappingURL=File.js.map